class Footer {
    constructor() {
        this.init();
    }

    init() {
        this.scrollToTop();
    }

    scrollToTop() {
        const element = document.querySelector('[data-scroll-to-top]');
        if (!element) return false;

        element.addEventListener('click', e => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        });
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/assets/js/components/Footer.js